export const GlobalManufacturerHarvestStatus = {
  SENT_FOR_SCRAPING: 'SENT_FOR_SCRAPING',
  SCRAPING_COMPLETED: 'SCRAPING_COMPLETED',
};

export const GlobalManufacturerHarvestStatusLabels = {
  [GlobalManufacturerHarvestStatus.SENT_FOR_SCRAPING]: 'Sent for Scraping',
  [GlobalManufacturerHarvestStatus.SCRAPING_COMPLETED]: 'Scraping Completed',
};
